export class TimeSlotType
{
    static readonly INSPECTION: string = "INSPECTION";
    static readonly UNAVAILABLE: string = "UNAVAILABLE";
    static readonly NATIONAL_HOLIDAY: string = "NATIONAL_HOLIDAY";
}